import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ConnectedLegendModal } from '../LegendModal';
import './Legend.css';
import { PrimaryButton } from '../../../PrimaryButton';
import { SuiteActions } from '../../../../store';
import * as util from '../../../../utils/urlParams';

export class Legend extends Component {
  state = {
    isModalOpen: false,
  };

  saveChanges = (modalSuiteLineColors, modalAvailableColors) => {
    const {
      location,
      navigationParams: { selectedSubCategory },
      suiteLineColors,
    } = this.props;
    const { search } = location;
    const filter = util.getFilterFromUrlParams(search);
    const thermostat = util.getThermostatFromUrlParams(search);

    if (suiteLineColors !== modalSuiteLineColors) {
      const newDataPoints = Object.keys(modalSuiteLineColors);

      // Push the new url
      const newSearch = util.addThermostatSearchParams(filter, thermostat, newDataPoints);
      this.props.history.push(`${selectedSubCategory.url}?${newSearch}`);

      // Set the customDataPoints as well as the lineColor variables to the selected ones
      this.props.updateLineColors(modalSuiteLineColors, modalAvailableColors);
      this.props.updateSelectedPointsList();
    }
    this.closeModal();
  };

  openModal = () => {
    this.setState((state) => ({
      ...state,
      isModalOpen: true,
    }));
  };

  closeModal = () => {
    this.setState((state) => ({
      ...state,
      isModalOpen: false,
    }));
  };

  renderLegendItems() {
    const { displayedItems, suiteLineColors } = this.props;

    return (
      <div>
        {displayedItems.map((dataset, index) => {
          const { status, name, id } = dataset;
          const columnClass = 'legend__equal-width';
          const lineNumber = suiteLineColors[id] || '';
          const lineStyle = `line ${lineNumber}`;
          const key = `${name}${index}`;
          return (
            <div key={key} className="legend__item">
              <div className={columnClass}>
                <div className={lineStyle} />
              </div>
              <div className={columnClass}>{name}</div>
              <div className={columnClass}>{status}</div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { isModalOpen } = this.state;

    return (
      <React.Fragment>
        <div className="legend">
          <div className="legend__header">
            <div className="legend__title">Legend</div>
            <PrimaryButton icon="edit-icon" label="Add/Remove Lines" onClick={this.openModal} />
          </div>
          <div className="legend__column-names">
            <div className="legend__equal-width">LINE STYLE</div>
            <div className="legend__equal-width">DATA SET</div>
            <div className="legend__equal-width">STATUS</div>
          </div>
          {this.renderLegendItems()}
        </div>
        {isModalOpen ? <ConnectedLegendModal onRequestClose={this.closeModal} saveChanges={this.saveChanges} /> : null}
      </React.Fragment>
    );
  }
}

Legend.propTypes = {
  displayedItems: PropTypes.arrayOf(
    PropTypes.shape({
      api_location: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      status: PropTypes.string,
    }),
  ),
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  navigationParams: PropTypes.shape({
    selectedCategory: PropTypes.shape({
      api_location: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.string,
      name: PropTypes.string,
      sub_categories: PropTypes.arrayOf(
        PropTypes.shape({
          api_location: PropTypes.string,
          data_api_location: PropTypes.string,
          id: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
        }),
      ),
      url: PropTypes.string,
    }),
    selectedSubCategory: PropTypes.shape({
      api_location: PropTypes.string,
      data_api_location: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
  selectedSubCategory: PropTypes.shape({
    api_location: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  suiteLineColors: PropTypes.object.isRequired,
  updateLineColors: PropTypes.func.isRequired,
  updateSelectedPointsList: PropTypes.func.isRequired,
};

Legend.defaultProps = { displayedItems: [], selectedSubCategory: {} };

export function mapStateToProps(state) {
  return {
    selectedSubCategory: state.buildingReducer.selectedSubCategory,
    navigationParams: state.buildingReducer.navigationParams,
    suiteLineColors: state.suiteReducer.suiteLineColors,
  };
}

const mapDispatchToProps = {
  updateSelectedPointsList: SuiteActions.updateSelectedPointsList,
  updateLineColors: SuiteActions.updateLineColors,
};

const LegendWithRouter = withRouter(Legend);
const ConnectedLegendWithRouter = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LegendWithRouter);
export { ConnectedLegendWithRouter };
